/** @format **/
import React, { FunctionComponent } from 'react';
import { TableCell, TableRow } from '@material-ui/core';
import { SimCardServiceGroupCollection, SimCardServiceTypeItem } from '../../interfaces/collections/SimCardServiceInterface';
import EditButton from '../../components/Buttons/EditButton';
import I18n from '../../components/Translate/I18n';
import OPL_STYLE from '../../assets/themes/OPL/OplStyle';
import withStyles from '@material-ui/core/styles/withStyles';
import OplAppStyle from '../../assets/themes/OPL/jss/App/OplAppStyle';

type ServicesListItemType = {
    classes: any;
    item: SimCardServiceTypeItem;
    setActiveRow: (id: number) => void;
    activeRow: number;
    viewCallback: (iri: { uri: string }, event: any) => void;
    simCardServiceGroupList: SimCardServiceGroupCollection | null;
};

const ServicesListItem: FunctionComponent<ServicesListItemType> = ({
    item,
    activeRow,
    setActiveRow,
    viewCallback,
    simCardServiceGroupList,
    classes,
}): React.ReactElement => {
    const tableControlStickyHeader = { root: classes.tableControlStickyHeader };
    const tableCellRoot = { root: classes.tableCellRootBordered };
    const tableRowRoot = { root: classes.tableRowRoot };

    let rowActiveColor = 'white';
    if (activeRow === item.id) {
        rowActiveColor = OPL_STYLE.TABLE.ACTIVE_ROW;
    }

    const getGroupName = (groupId: number): string => {
        const name = '';
        if (simCardServiceGroupList && simCardServiceGroupList['hydra:member'].length > 0) {
            for (let i = 0; i < simCardServiceGroupList['hydra:member'].length; i++) {
                if (simCardServiceGroupList['hydra:member'][i].id === groupId) {
                    return simCardServiceGroupList['hydra:member'][i].mainname;
                }
            }
        }
        return name;
    };

    return (
        <TableRow
            classes={tableRowRoot}
            key={'key' + item.id}
            hover
            onClick={(): void => {
                setActiveRow(item.id);
            }}
            style={{ backgroundColor: rowActiveColor }}
        >
            <TableCell classes={tableControlStickyHeader} padding="none" align="left" style={{ backgroundColor: rowActiveColor }}>
                <EditButton
                    callback={viewCallback}
                    callbackParam={{ uri: item['@id'] }}
                    tooltipTitle="prov:features.view_features"
                    tooltipPlacement="bottom-start"
                />
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="left">
                {item.mainname}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="left">
                {getGroupName(item.groupId)}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="left">
                {item.description}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="left">
                {item.comment}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="left">
                {<I18n trans={item.available ? 'general:common.yes' : 'general:common.no'} />}
            </TableCell>
            <TableCell classes={tableCellRoot} padding="none" align="left">
                {item.serviceType}
            </TableCell>
        </TableRow>
    );
};

export default withStyles(OplAppStyle)(ServicesListItem);
